import CoreStyles from '../../utils/styles/core-styles';

const ExpressCheckoutCompleteStyles = theme => ({
  header: {
    fontSize: '22px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: 10,
  },
  card: {
    //padding: ['30px 16px', '!important']
  },
  ...CoreStyles(theme)
});

export default ExpressCheckoutCompleteStyles;
